// extracted by mini-css-extract-plugin
export default {"title":"portfolioSegmentation_title__80j53"};